import React from 'react';

import { Tab } from '@ariakit/react';
import classNames from 'classnames';

import * as classes from './style.module.scss';

interface Props {
  file: string;
  id?: string;
  activeId?: string | null | undefined;
  index?: number;
  interactive?: boolean;
}

export const CodeBlockHeaderTab: React.FC<Props> = ({
  id,
  activeId,
  index,
  file,
  interactive = false,
}) => {
  const Component = interactive ? Tab : 'div';

  return (
    <div
      className={classNames(classes.root, {
        [classes.root__is_active]: !interactive || id === activeId,
        [classes.root__is_first]:
          !interactive || (index === 0 && id === activeId),
      })}
    >
      <Component
        className={classNames(classes.tab, {
          [classes.tab__is_interactive]: interactive,
          [classes.tab__is_active]: !interactive || id === activeId,
          [classes.tab__is_interactive_and_active]:
            interactive && id === activeId,
        })}
        id={id}
        aria-controls={`${id}-panel`}
      >
        {file}
      </Component>
    </div>
  );
};
